export function showSuccess(msg) {
  console.log("✅", msg);
  // toast.success(msg); // if using toast lib
}

export function showWarning(msg) {
  console.warn("⚠️", msg);
  // toast.warn(msg);
}

export function showError(msg) {
  console.error("❌", msg);
  // toast.error(msg);
}
